export default __webpack_public_path__ + "static/media/showcase-icon.2f091dbc.svg";